import { Button, Input } from '@lokalise/louis'
import type { Integrations } from '@lokalise/translation-api-schemas'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../../constants/url'
import { AiModelSelect } from '../../../AiModelSelect/AiModelSelect'
import { TmTargetLanguagesView } from '../../../KeysForLanguage/components/TmTargetLanguagesView/TmTargetLanguagesView'
import {
  KeysForLanguageBorderWrapper,
  KeysForLanguageContainer,
  KeysForLanguageContents,
  KeysForLanguageHeader,
  KeysForLanguagesProjectDetails,
  KeysForLanguagesSourceArrow,
  KeysForLanguagesSourceCard,
  KeysForLanguagesTargetLanguagesContainer,
} from '../../../KeysForLanguage/KeysForLanguage'
import {
  StepContainer,
  StepContents,
  StepFooter,
  StepRSP,
  StepSubtitle,
  StepTitle,
  StepTitleContainer,
} from '../../../Step/Step'
import { StyledLink } from '../../../StyledLink/StyledLink'
import styles from '../../../UserCreatedProfileModal/components/ProfileBasicsStep/ProfileBasics.module.css'

type ProfileBasicsStepProps = {
  profileName: string
  selectedAiModel: Integrations
  onAiModelSelected: (aiModel: Integrations) => void
  onNext: () => void
  onClose: () => void
}

export const TmBasicSettingsStep = ({
  profileName,
  selectedAiModel,
  onAiModelSelected,
  onNext,
  onClose,
}: ProfileBasicsStepProps) => (
  <StepContainer>
    <StepContents>
      <StepTitleContainer>
        <StepTitle>Basic settings</StepTitle>
        <StepSubtitle>
          Change basic profile settings, like the LLM provider. Routing is enabled by default for
          optimal translation quality across all languages in assigned projects{' '}
          <StyledLink href={AI_PROFILES_DOCUMENTATION_URL} rel="noreferrer" target="_blank">
            docs.
          </StyledLink>
        </StepSubtitle>
      </StepTitleContainer>
      <div className="flex-col gap-5">
        <div className="flex-col gap-2">
          <span className={styles.heading}>Name AI profile</span>
          <Input disabled value={profileName} />
        </div>
        <AiModelSelect selectedModel={selectedAiModel} onModelChange={onAiModelSelected} />
      </div>
      <StepFooter>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onNext} variant="primary">
          Next
        </Button>
      </StepFooter>
    </StepContents>
    <StepRSP>
      <KeysForLanguageContainer>
        <KeysForLanguageBorderWrapper>
          <KeysForLanguageHeader name={profileName} integration={selectedAiModel} />
          <KeysForLanguageContents>
            <KeysForLanguagesSourceCard />

            <KeysForLanguagesSourceArrow />

            <KeysForLanguagesTargetLanguagesContainer>
              <TmTargetLanguagesView />
            </KeysForLanguagesTargetLanguagesContainer>

            <KeysForLanguagesProjectDetails />
          </KeysForLanguageContents>
        </KeysForLanguageBorderWrapper>
      </KeysForLanguageContainer>
    </StepRSP>
  </StepContainer>
)
